import { clientConfig } from './src/clientConfig/clientConfig';

export const API_TIMEOUT = !isNaN(clientConfig.API_TIMEOUT) ? parseInt(clientConfig.API_TIMEOUT) : 8000;
